exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.compact-dropdown .dropdown-toggle {\n  height: 1.5rem !important;\n  width: 150px !important;\n}\n.compact-dropdown .dropdown-toggle .vs__actions {\n    top: 3px !important;\n}\n.compact-dropdown .dropdown-toggle .selected-tag,\n  .compact-dropdown .dropdown-toggle input[type=search] {\n    height: 1.4rem !important;\n    margin: 0 !important;\n    line-height: 1.4rem !important;\n    font-size: 11px !important;\n}\n.compact-dropdown .dropdown-menu {\n  font-size: 11px !important;\n}\n.compact-dropdown .dropdown-menu li[role=option] a {\n    padding-left: 15px !important;\n}\n.compact-dropdown .open-indicator {\n  height: 14px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0b0345f3","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/calendar/EventDetails.vue
// module id = 2655
// module chunks = 0